export type SandboxAccessFlagKey =
  | 'chats'
  | 'notifications'
  | 'shout_plus'
  | 'products'
  | 'campaigns'
  | 'groups'
  | 'billing'
  | 'create_briefs'
  | 'find_creators';

export interface SandboxUserAccessDto {
  chats: boolean;
  notifications: boolean;
  shout_plus: boolean;
  products: boolean;
  campaigns: boolean;
  groups: boolean;
  billing: boolean;
  create_briefs: boolean;
  find_creators: boolean;
  allowed_creators: string[];
}

export interface AdminSandboxUserLookupDto {
  firebaseUid: string;
  email: string;
  firstName: string;
  lastName: string;
  createdDate?: string | Date;
  sandbox_user: boolean;
  sandboxAccess?: SandboxUserAccessDto | null;
}

export interface SandboxCreatorSearchRow {
  blazeFirebaseUid: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface SandboxCreatorSearchResponse {
  count: number;
  data: SandboxCreatorSearchRow[];
}

export const SANDBOX_ACCESS_FLAG_DEFS: readonly {
  key: SandboxAccessFlagKey;
  label: string;
  description: string;
}[] = [
  { key: 'chats', label: 'Chats', description: 'Inbox and Stream messaging' },
  { key: 'notifications', label: 'Notifications', description: 'Outbound emails and alerts' },
  { key: 'shout_plus', label: 'SHOUT+', description: 'SHOUT+ activation and flows' },
  { key: 'products', label: 'Products', description: 'UGC / Shopify products' },
  { key: 'campaigns', label: 'Campaigns', description: 'Campaign groups' },
  { key: 'groups', label: 'Groups', description: 'Recruit groups (My Creators)' },
  { key: 'billing', label: 'Billing', description: 'Wallet, payments, top-up, subscriptions' },
  { key: 'create_briefs', label: 'Create briefs', description: 'Brief creation (always private)' },
  { key: 'find_creators', label: 'Find creators', description: 'Creator search and browse' },
] as const;

export function emptySandboxAccess(): SandboxUserAccessDto {
  return {
    chats: false,
    notifications: false,
    shout_plus: false,
    products: false,
    campaigns: false,
    groups: false,
    billing: false,
    create_briefs: false,
    find_creators: false,
    allowed_creators: [],
  };
}
